import { combineReducers } from "redux";
import { reducer as licenseReducer } from "./license";
import { reducer as themeReducer } from "./theme";
import { reducer as userReducer } from "./user";
import { reducer as bookReducer } from "./book";
import { reducer as overleafReducer } from "./overleaf";
import { reducer as feenyReducer } from "./feeny";
import { reducer as ancillariesReducer } from "./ancillaries";
import { reducer as uiReducer } from "./ui";
import { reducer as markersReducer } from "./markers";
import { reducer as bridgeReducer } from "./bridge";
//import { routerReducer } from "react-router-redux";
import { reducer as routerReducer } from "./router";
import { reducer as modalsReducer } from "./modals";
import { reducer as collectionsReducer } from "./collections";
import { reducer as searchReducer } from "./search";
import { reducer as toastsReducer } from "./toasts";
import { reducer as highlightSummaryReducer } from "./highlights";
import { reducer as booksReducer } from "./books";
import { reducer as brandReducer } from "./brand";
import { reducer as localeReducer } from "./locale";
import { reducer as storageReducer } from "./storage";
import { reducer as citationReducer } from "./citations";
import { reducer as favoritesReducer } from "./favorites";
import { createPersistedReducer } from "./persist";
import { stateToStorage, storageToState } from "./books/persist";

const rootReducer = combineReducers({
  ancillaries: ancillariesReducer,
  book: bookReducer,
  license: licenseReducer,
  books: combineReducers({
    jigsaw: createPersistedReducer({
      reducer: booksReducer,
      storageKey: "jigsawBooks",
      stateToStorage,
      storageToState,
    }),
  }),
  brand: brandReducer,
  bridge: bridgeReducer,
  collections: collectionsReducer,
  feeny: feenyReducer,
  highlightSummary: highlightSummaryReducer,
  locale: localeReducer,
  markers: markersReducer,
  modals: modalsReducer,
  overleaf: overleafReducer,
  router: routerReducer,
  search: searchReducer,
  toasts: toastsReducer,
  storage: storageReducer,
  theme: themeReducer,
  ui: uiReducer,
  user: userReducer,
  citations: citationReducer,
  favorites: favoritesReducer,
});

export default rootReducer;
